export default __webpack_public_path__ + "static/media/pantry1-afterD-480w.116a56d4.avif";